import {
  Sparkles,
  Shirt,
  Leaf,
  Hammer,
  SprayCan,
  Building2,
  HeartHandshake,
  Wrench,
  Sofa,
  PawPrint,
} from 'lucide-react';

const REGLES = [
  { motifs: ['ménage', 'menage', 'nettoyage domicile'], icone: Sparkles },
  { motifs: ['repassage', 'linge'], icone: Shirt },
  { motifs: ['jardin'], icone: Leaf },
  { motifs: ['bricolage', 'petit travaux'], icone: Hammer },
  { motifs: ['nettoyage', 'propreté', 'proprete'], icone: SprayCan },
  { motifs: ['syndic', 'copropriété', 'copropriete', 'immeuble', 'conciergerie'], icone: Building2 },
  { motifs: ['aide', 'domicile', 'personne âgée', 'personne agee'], icone: HeartHandshake },
  { motifs: ['maintenance', 'entretien', 'réparation', 'reparation'], icone: Wrench },
  { motifs: ['mobilier', 'déménagement', 'demenagement'], icone: Sofa },
  { motifs: ['animaux', 'animalier'], icone: PawPrint },
];

/** Devine une icône lucide pertinente à partir du nom d'un service/catégorie. */
export function getServiceIcon(nom = '') {
  const texte = nom.toLowerCase();
  const regle = REGLES.find((r) => r.motifs.some((motif) => texte.includes(motif)));

  return regle ? regle.icone : Sparkles;
}
